import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ActivityStreamComponent} from "./dashboard/activity-stream/activity-stream.component";
import {SavedFiltersComponent} from "./dashboard/saved-filters/saved-filters.component";
import {FavouritesComponent} from "./dashboard/favourites/favourites.component";
import {EventsComponent} from "./dashboard/events/events.component";
import {FavouritesToggleComponent} from "./dashboard/favourites/favourites-toggle/favourites-toggle.component";
import {DashboardChangelogComponent} from "./dashboard/dashboard-changelog/dashboard-changelog.component";
import {NgbDropdownModule, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {InlineSVGModule} from "ng-inline-svg-2";
import {CommonSharedModule, HelpModule} from "common-shared";
import {RouterLink} from "@angular/router";
import {EventLevelPipe} from "./events/event-level.pipe";
import {EventViewModalComponent} from "./events/event-view/event-view-modal.component";
import {EventListComponent} from "./events/event-list/event-list.component";
import {TranslocoModule} from "@jsverse/transloco";
import {FormsModule} from "@angular/forms";
import {GlobalSearchComponent} from "./global-search/global-search.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {SavedFilterMenuItemComponent} from "./saved-filter-menu-item/saved-filter-menu-item.component";
import {TableModule} from "primeng/table";
import {UserListComponent} from "./user/list/user-list.component";
import {ActionBarModule} from "web-shared";
import {NgOptionHighlightModule} from "@ng-select/ng-option-highlight";
import { NewGlobalSearchComponent } from './global-search/new-global-search/new-global-search.component';

@NgModule({
  declarations: [
    ActivityStreamComponent,
    SavedFiltersComponent,
    FavouritesComponent,
    EventsComponent,
    DashboardChangelogComponent,
    FavouritesToggleComponent,
    EventListComponent,
    EventViewModalComponent,
    EventLevelPipe,
    GlobalSearchComponent,
    SavedFilterMenuItemComponent,
    UserListComponent,
    NewGlobalSearchComponent
  ],
  exports: [
    ActivityStreamComponent,
    SavedFiltersComponent,
    FavouritesComponent,
    EventsComponent,
    DashboardChangelogComponent,
    FavouritesToggleComponent,
    GlobalSearchComponent,
    NewGlobalSearchComponent,
    SavedFilterMenuItemComponent
  ],
  imports: [
    CommonModule,
    NgbDropdownModule,
    InlineSVGModule,
    CommonSharedModule,
    RouterLink,
    TranslocoModule,
    FormsModule,
    NgSelectModule,
    TableModule,
    ActionBarModule,
    NgbTooltip,
    NgOptionHighlightModule,
    HelpModule
  ]
})
export class ImeComponentsModule { }
